import { api } from './client.js';

/** Resolves Netlify Identity user ids to { id, email } — safe for any authenticated user, not admin-only. */
export const userLookupApi = {
  lookup: (ids) => api.post('/api/users/lookup', { ids }),
};
